import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.posts-block__slider')

  if (!wrapper.length) {
    return
  }

  const posts = $block.find('.feed-post')

  const sliderInstance = new Swiper(wrapper[0], {
    slidesPerView: 1,
    spaceBetween: 30,
    on: {
      init: (instance) => {
        posts.eq(instance.activeIndex).addClass('active')
      },
      slideChangeTransitionStart: (instance) => {
        posts.removeClass('active')
        posts.eq(instance.activeIndex).addClass('active')
      },
    },
  })

  posts.on('click', function () {
    sliderInstance.slideTo($(this).index())
  })
}

$('.posts-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=cc-posts', initializeBlock)
}
